<template>

  <div class="equipment-container">
    <h3>{{label}}</h3>
    <div class="checkbox-category">
      <div class="equipment-item check-ctn" v-for="equipment in type" :key="equipment.id">
        <label>{{equipment.name}}<input type="checkbox"  name="features[]" :data-label="equipment.name" :id="'attributes-' + equipment.id" :value="equipment.id" :checked="equipment.selected" > <span class="checkmark"></span></label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Equipment",
  props: {
    type: {
      type: Array,
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      equipments: this.type

    }
  },
  watch: {
    type: function() {
      this.equipments = this.type;
    }
  }
}
</script>

<style scoped>

</style>